import React, { Component } from "react";
import { Field, Formik, Form } from "formik";
import { service } from "../redux";
import Select from "react-select";
import { ClipLoader } from "react-spinners";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import * as moment from "moment";
import { utils } from "../../../utils/utils";
import "react-datepicker/dist/react-datepicker.css";

class ReportComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
        };
    }

    render() {
        let date = new Date();
        return (
            <div className="container">
                <Formik
                    initialValues={{
                        filter_by: "",
                        start_date: null,
                        end_date: null,
                        customers_team_name: "",
                    }}
                    onSubmit={(values, { resetForm }) => this.handleSubmit(values, resetForm)}>
                    {formik => {
                        const { values, setFieldValue } = formik;
                        return (
                            <Form>
                                <div className="row">
                                    <div className="form-group col-md-6">
                                        <label>Search by</label>
                                        <Field
                                            name="filter_by"
                                            component={Select}
                                            value={values.filter_by}
                                            isClearable
                                            cacheOptions
                                            defaultOptions
                                            options={
                                                [
                                                    { value: "date", label: "CPO date" },
                                                    { value: "creation_date", label: "CPO receipt date (ZINA)" },
                                                ]
                                            }
                                            onChange={val => setFieldValue("filter_by", val, false)}
                                            validate={utils.validateGeneral}
                                        />

                                        {this.renderError(formik, "filter_by")}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="form-group col-md-3">
                                        <label>Start date <small><i>(dd/mm/yy)</i></small></label>
                                        <Field
                                            component={DatePicker}
                                            dateFormat="dd/MM/yyyy"
                                            onChange={value => setFieldValue("start_date", value, false)}
                                            name="start_date"
                                            autoComplete="off"
                                            maxDate={date}
                                            selected={values.start_date}
                                            className="form-control"
                                            validate={utils.validateGeneral}
                                            popperPlacement={"top-end"}
                                            popperModifiers={{
                                                preventOverflow: {
                                                    enabled: true,
                                                },
                                            }}
                                        />
                                        {this.renderError(formik, "start_date")}
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>End date <small><i>(dd/mm/yy)</i></small></label>
                                        <Field
                                            component={DatePicker}
                                            dateFormat="dd/MM/yyyy"
                                            onChange={value => setFieldValue("end_date", value, false)}
                                            name="end_date"
                                            maxDate={date}
                                            autoComplete="off"
                                            selected={values.end_date}
                                            className="form-control"
                                            validate={utils.validateGeneral}
                                            popperPlacement={"top-end"}
                                            popperModifiers={{
                                                preventOverflow: {
                                                    enabled: true,
                                                },
                                            }}
                                        />
                                        {this.renderError(formik, "end_date")}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="form-group col-md-6">
                                        <label>Customer team</label>
                                        <Field
                                            name="customers_team_name"
                                            component={Select}
                                            value={values.customers_team_name}
                                            isClearable
                                            cacheOptions
                                            defaultOptions
                                            options={[
                                                { value: "Alstom", label: "Alstom" },
                                                { value: "bharti_airtel_india_parser", label: "Bharti airtel India" },
                                                { value: "bharti_infratel_limited", label: "Bharti infratel limited" },
                                                { value: "BSNL", label: "BSNL" },
                                                { value: "Indian_Railways", label: "Indian railways" },
                                                { value: "MTNL", label: "MTNL" },
                                                { value: "vodafone_idea_limited_india", label: "Vodafone idea india" },
                                                { value: "reliance_jio_parser", label: "Reliance Jio" },
                                            ]}
                                            onChange={val => setFieldValue("customers_team_name", val, false)}
                                            validate={utils.validateGeneral}
                                        />
                                        {this.renderError(formik, "customers_team_name")}
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-success ">
                                    Send report to email
                                </button>
                                {this.state.isLoading && (
                                    <div className="float-left">
                                        <ClipLoader />
                                    </div>
                                )}
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        );
    }
    handleSubmit = (values, resetForm) => {
        /**
        * This method handles data submitted from Formik form
        */
        this.setState({ isLoading: true });
        let months = utils.dateValidation(values.start_date, values.end_date)
        if (months >= 3.1) {
            utils.show_result_swal("Date range exceeds the maximum of 3 months", false, 'Error')
            this.setState({ isLoading: false })
            return
        }
        const reportParams = {
            customer_team: values.customers_team_name ? values.customers_team_name : null,
            [values.filter_by.value]: [moment(values.start_date).format("DD/MM/YYYY"), moment(values.end_date).format("DD/MM/YYYY")]
        };
        service.sendReport(reportParams).then(response => {
            this.setState({ isLoading: false });
            // Handle OK responses
            if (response.status === 200) {
                const msg = "The report will be sent to your email."
                resetForm();
                return utils.show_result_swal(msg, true, 'Success')
            }
            // Handle error responses
            const msg = utils.computeError(response)
            return utils.show_result_swal(msg, false, 'Error')
        });
    }
    renderError = (formik, type) => {
        if (formik.errors.hasOwnProperty(type) && formik.errors[type]) {
            return <small className="text-danger form-text">{formik.errors[type]}</small>;
        }
        return null;
    };

}

const mapStateToProps = state => {
    return {
        cpo: state.cpo
    };
};

export default connect(mapStateToProps)(ReportComponent);
